<!-- 配品信息 -->
<template>
    <div class="goods-info">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <div class="left search flex flex-align-center" style="width:120px;">
                            <input type="text" class="left" placeholder="请输入配品名" v-model="goods">
                            <i class="el-icon-search" @click="searchGoods"></i>
                            <ul class="details_search" @click.stop="" :style="{display:(goodCheckArr[0]?'block':'none')}">
                                <div class="leftIcon" :style="{top:(curGoodIdx*40+'px')}">
                                    <div class="iconInner"></div>
                                </div>
                                <li v-for="item in goodCheckArr" @click="selSearchGood(item,'search')">
                                    <div class="left name ellipsis" v-text="item.name" :title="item.name"></div>
                                </li>
                            </ul>
                        </div>
                        <div class="fliter type">
                            分类选择：
                            <el-select v-model="fliter_type" style="width:120px;">
                                <el-option key="" label="全部" value=""></el-option>
                                <el-option 
                                    v-for="item in systemData"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"></el-option>
                                <el-option 
                                    v-for="item in typeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                            <!-- <el-cascader
                                v-model="fliter_type"
                                :options="typeOptions"
                                :show-all-levels="false"
                            ></el-cascader> -->
                        </div>
                        <span class="fliter">
                            管理库存：
                            <el-select v-model="fliter_stock">
                                <el-option key="" label="全部" value=""></el-option>
                                <el-option key="true" label="是" value="true"></el-option>
                                <el-option key="false" label="否" value="false"></el-option>
                            </el-select>
                        </span>
                        <!-- <span class="fliter">
                            厨房打印：
                            <el-select v-model="fliter_kitchen">
                                <el-option key="" label="全部" value=""></el-option>
                                <el-option key="true" label="是" value="true"></el-option>
                                <el-option key="false" label="否" value="false"></el-option>
                            </el-select>
                        </span> -->
                        <div class="left searchBtn" style="padding-left:10px;">
                            <button type="button" @click="fliterGoods" style="padding: 0 10px">筛选</button>
                        </div>
                        <div class="right searchBtn">
                            <button type="button" @click="addGoods"><i class="el-icon-plus"></i>添加配品</button>
                        </div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:4%">序号</th>
                                <th style="width:10%">配品名</th>
                                <th style="width:8%">分类</th>
                                <th style="width:6%">销售价</th>
                                <!-- <th style="width:5%">管理库存</th> -->
                                <th style="width:12%">操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:vipData.length > 6}">
                                    <tr v-for="(item,idx) in vipData">
                                        <td style="width:4%" v-text="item.id?(idx+1):''"></td>
                                        <td style="width:10%" v-text="item.name" :title="item.name"></td>
                                        <td style="width:8%" v-text="item.typeName"></td>
                                        <td style="width:6%" v-text="item.salesPrice"></td>
                                        <!-- <td style="width:5%" >
                                            <span
                                                class="goods_status_on"
                                                v-if="item.id"
                                                :class="{goods_status_off:!item.stockEnabled}"
                                                v-text="item.stockEnabled?'是':'否'">
                                            </span>
                                        </td> -->
                                        <td style="width:12%">
                                            <div v-if="item.id" class="btnInline">
                                                <el-button type="text"  title="修改" @click="uploadGood(item)"><i class="iconfont icon-bianji"></i></el-button>
                                                <el-button type="text"  title="删除" @click="delGoods(item.id)"><i class="iconfont icon-icon1460188478041"></i></el-button>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            :title="btnId?'修改配品':'添加配品'"
            :visible.sync="dialogVisible"
            size="tiny"
            v-loading.body="infoload">
            <div>
                <div class="msgBox clearfix" @click="hideSearchList">
                    <div class="left msgItem clearfix searchbox">
                        <span class="left itemName"><i>*</i>配品名</span>
                        <input type="text" class="left itemInput" v-model="newGoods.name" placeholder="请输入配品名">
                         <ul class="details_search add_details_search" @click.stop="" :style="{display:(addGoodCheckArr[0]?'block':'none')}">
                            <div class="leftIcon" :style="{top:(addCurGoodIdx*40+'px')}">
                                <div class="iconInner"></div>
                            </div>
                            <li v-for="item in addGoodCheckArr" @click="selSearchGood(item,'add')">
                                <div class="left name ellipsis" v-text="item.name" :title="item.name"></div>
                            </li>
                        </ul>
                    </div>
                    <div class="left msgItem clearfix" >
                        <span class="left itemName"><i>*</i>配品分类</span>
                        <el-select placeholder="请选择配品分类" v-model="newGoods.productTypeId" class="itemSelect" style="width:40%;">
                            <el-option 
                                    v-for="item in systemData"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"></el-option>
                            <el-option
                                v-for="item in typeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>价格</span>
                        <input type="text" style="width:50px;text-align:center;" class="left itemInput" v-model="newGoods.salesPrice" placeholder="价格">
                        <span class="left">元</span>
                    </div>
                    <!-- <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>管理库存</span>
                        <el-radio class="radio left itemRadio" v-model="isStock" label="ON">是</el-radio>
                        <el-radio class="radio left itemRadio"  v-model="isStock" label="OFF">否</el-radio>
                    </div> -->
                    <div class="left mat-goods">
                        <span class="tit">包含原料:</span>
                        <span class="seled-mat-list">
                            <el-tag
                            v-for="tag in seledMats"
                            :key="tag.name"
                            >
                            {{tag.name}}*{{tag.count}}
                            </el-tag>
                        </span>
                        <el-button type="text" @click="addMatGoods">+添加</el-button>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="dialogVisible=false" class="cancel">取消</button>
                <button type="button" @click="upGoods" class="save">保存</button>
            </span>
        </el-dialog>
        <img-crop v-if="showCrop" :oldImg="oldImgBase64" :curCropW="curCropW" :curCropH="curCropH" :curStoreId="curStoreId" @closeImgCrop="showCrop=false" @getCropImgBase="getCropImgBase"></img-crop>
        <selGoods 
            v-if="showMat"
            @selOk="selOk"
            :seledGoods="seledMats"
            :storeId="curStoreId"
            @closeSelGoods="showMat=false"
        />
    </div>
</template>

<script type="text/javascript">
    import imgCrop from '@/components/imgCrop/imgCrop.vue';
    import {API_BASE_URL} from "./../../../urlConfig/index";
    import selGoods from "@/components/selGoods/selGoods";
    export default{
        components: {imgCrop,selGoods},
        props: ['curStoreId'],
    	data () {
    		return {
                showMat:false,
                seledMats: [
                ],
                isAllWeek:false,
                weeks: [
                    "星期一",
                    "星期二",
                    "星期三",
                    "星期四",
                    "星期五",
                    "星期六",
                    "星期天",
                ],
                timeChoiceBtnForComm:false,
                printEr:[],
                pcEnable:true,
                pcBuyEnable:true,
                disCom:0,//开启折扣价后的提成金额
                beginTime:"",
                endTime:"",
                // croseDay:false,
                discountEnable:false,
                discountPrice:100,//折扣价格
                vipEnable:false,
                vipPrice:"",//会员价格
                systemData:[],
                timeList:[],
                timeChoice:'',
                timeChoiceForComm:["",""],
                timeChoiceBtn:false,
                newTimeList:[],
                newTimeListForComm:[{
                    commission:"",
                    timeRange:[]
                }],//提成时间段
                checkeds:false,
                isStock:'ON',//是否库存管理
                kitchenPrintEnabled:'OFF',//是否厨房打印
                isDirectThermal: 'OFF', // 是否贴纸打印
                dialogVisible: false,
                newGoods: {
                    timeRangeComm:false,
                    sort:0,
                    salesCount:0,
                    salesShowEnabled:false,
                    salesEnabled:false,
                // 
                    labelEnabled:0,//标签打印
                    id: '', // 员工id
                    productTypeId: '', // 员工id
                    name: '', // 员工姓名
                    barCode: '', // 条码
                    // costPrice: '', // 进价
                    salesPrice: '', // 出售价
                    storeId: this.curStoreId, // 商铺id
                    inStockNumber: '' ,// 库存
                    supplierName: '', // 供应商
                    supplyTimeEnd: '', // 起售时间
                    supplyTimeBegin: '', // 止售时间
                    productStatus: 'ON', // 状态
                    imageURL: '', // 图片路径
                    // stockQuantityRatio: '', // 每件多少个
                    commission:'0',//提成价格，默认为0
                    productQty:1,//配品数量默认为1
                    ipId:"",
                    threshold:0,//库存告警值
                    note:"",
                    week:[]
                },
                vipData:[],//所有配品列表
                goodsNum:{
                    pageNum:1,
                    pageSize:6,
                    total:0
                },
                btnId:'',//添加或修改配品按钮
                addId:'',
                coverImgMaxSize: 5*1024*1024, // 图片最大字节数
                oldImgBase64: '', // 原图base64
                showCrop: false, // 控制图片裁剪显示隐藏
                curCropW: 600, // 裁剪宽度
                curCropH: 600, // 裁剪高度
                infoload: false, // loading

                addGoodApiBtn: true, // 控制添加配品接口

                goodCheckArr:[],
                addGoodCheckArr:[],//添加配品搜索出来的配品列表
                isAutoSearchBtn:true,//添加配品是否开启检索
                addCurGoodIdx: 0, // 当前配品索引
                goods:'',
                curGoodIdx: 0, // 当前配品索引
                goodSearchBtn:true,

                fliter_type: '', // 当前筛选条件
                fliter_status: '', // 当前筛选条件
                fliter_stock: '', // 当前筛选条件
                fliter_kitchen: '', // 当前筛选条件
                typeList:[],
                multipleSelection:[],
                matData:[],
                unitOptions:[],
                unitFormat:{}
    		}
    	},
        watch:{
            // "newGoods.timeRangeComm":function(val){
            //     if(val){
            //        $("#comm").parents(".msgItem").css("margin-bottom",this.newTimeListForComm.length * 25);
            //     }else{
            //         this.newTimeListForComm = [];
            //     }
            // },
            // newTimeListForComm:function(val){
            //     // if(this.newTimeListForComm.length){
            //        $("#comm").parents(".msgItem").css("margin-bottom",val.length * 25);
            //     // }
            // },
            newTimeList:function(val){
                // if(this.newTimeListForComm.length){
                    console.log($("#timeSales").parents(".msgItem").css("margin-bottom",val.length * 25));
                // }
            },
            goods : function(val){
                if(val){
                    this.searchGoods(val,null)
                }else {
                    this.goodCheckArr = [];
                    this.getGoodsData();
                }
            }, 
            'newGoods.name' : function(val){
                if(val){
                    // if(this.isAutoSearchBtn){
                        this.searchGoods(val,'9f5afd60-e952-11e7-a26a-83436326b6c5');
                    // }else {
                        
                    // }
                }else {
                    this.addGoodCheckArr = [];
                    // this.getGoodsData();
                }
            },
            timeChoice(val){
                if(val==''){
                    return;
                }
                if(this.newTimeList.length>=3){
                    this.$message({
                        message: '最多只能添加3个时间段',
                        customClass: 'error'
                    })
                    this.timeChoice = '';
                    return;
                }
                for (var i = 0; i < this.timeList.length; i++) {
                    if(val == this.timeList[i].id){
                        
                        let isPush = true;
                        for(var j=0;j<this.newTimeList.length;j++){
                            if(this.newTimeList[j].id == val){
                                isPush = false;
                                this.$message({
                                    message: '已经有该时段',
                                    customClass: 'error'
                                })
                            }
                        }
                        if(isPush){
                            this.newTimeList.push(this.timeList[i]); 
                        }
                    }
                }
                this.timeChoiceBtn = false;
                this.timeChoice = '';
            } ,
            // timeChoiceForComm(val){
            //     console.log(val)
            //     return;
            //     if(val==''){
            //         return;
            //     }
            //     if(this.newTimeListForComm.length>=5){
            //         this.$message({
            //             message: '最多只能添加5个时间段',
            //             customClass: 'error'
            //         })
            //         this.timeChoiceForComm = '';
            //         return;
            //     }
            //     this.newTimeListForComm.push(val); 
            //     this.timeChoiceForComm = '';
            // }
            dialogVisible(val){
                if(!val){
                    this.seledMats = [];
                }
            }
        },
        methods: {
            saveSeledMats(){
                let seledMats = JSON.parse(JSON.stringify(this.seledMats));
                let willbeSel = this.multipleSelection;
                seledMats = willbeSel;
                this.seledMats = seledMats;
                console.log(seledMats)
                this.showMat = false;
            },
            getUnitList(){
                this.$http({
                    url:"material/unit/list",
                    method:"GET",
                    params:{
                        storeId:this.curStoreId,
                        page:0,
                        size:10000
                    }
                }).then(res=>{
                    this.unitOptions = res.data;
                    let unitFormat = {};
                    if(res.data && Array.isArray(res.data) && res.data.length){
                        res.data.forEach(it=>{
                            unitFormat[it.id] = it.name
                        })
                    }
                    console.log(unitFormat)
                    this.unitFormat = unitFormat;
                    this.getDataList();
                })
            },
            getDataList(){
                this.$http({
                    url:"material/search/list",
                    method:"GET",
                    params:{
                        storeId:this.curStoreId,
                        page:0,
                        size:10000
                    }
                }).then(res=>{
                    this.matData = res.data;
                })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            addMatGoods(){
                this.showMat = true;
                // this.getUnitList();
            },
            handleChangeWeeks(value) {
                console.log(value)
                // this.newGoods.week = value;
            },
            handleChangeWeeksAll(val){
                if(this.isAllWeek){
                    this.newGoods.week = this.weeks;
                }else{
                    this.newGoods.week = [];
                }
            },
            addCommTime(){
                let obj = {
                    commission:"",
                    timeRange:[]
                }
                this.newTimeListForComm.push(obj);
            },
            setTimeForComm(){
                console.log(new Date(this.timeChoiceForComm[0]).Format("hh:mm"))
                if(this.newTimeListForComm.length>=5){
                    this.$message({
                        message: '最多只能添加5个时间段',
                        customClass: 'error'
                    })
                    this.timeChoiceForComm = '';
                    return;
                }
                let obj = {
                    commPrice:"",
                    start:"",
                    end:""
                }
                this.newTimeListForComm.push(obj); 
                this.timeChoiceForComm = '';
            },
            // 获取打印数据
            getPrintIpInfo(){
                this.$http({
                url:"ip-list",
                method:"GET",
                params:{
                    storeId:this.curStoreId
                    }
                }).then(res=>{
                    this.printEr = res.data;
                    console.log(res);
                });
            },
            // 隐藏添加配品、修改配品时的配品名字检索
            hideSearchList(){
                this.addGoodCheckArr = [];
            },
            // 删除修改配品时的图片
            delImg(){
                this.$refs.goodsImg.src = 'https://hxypic.oss-cn-hangzhou.aliyuncs.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png';
                this.newGoods.imageURL = 'https://hxypic.oss-cn-hangzhou.aliyuncs.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png';
            },
            selSearchGood(item,boo){
                this.$http.get(item.id+'/product').then((res)=>{
                    if(boo=='add'){
                        console.log(res.data)
                        this.addGoodCheckArr = [];
                        this.addId = item.id;
                        this.newGoods = {
                            // barCode       : res.data.barCode,
                            // salesPrice    : res.data.salesPrice,
                            // inStockNumber : res.data.inStockNumber,
                            // supplierName  : res.data.supplierName,
                            name          : res.data.name,
                            imageURL      : res.data.imageURL,
                            productStatus : 'OFF',
                            labelEnabled:0,
                            timeRangeComm:false,
                            salesEnabled:false,
                            // stockQuantityRatio : res.data.stockQuantityRatio,
                            commission : 0,
                            week : res.data.week ? (Array.isArray(res.data.week) ? res.data.week : res.data.week.split(",")) : [],
                            // productQty:res.data.productQty
                        };
                        this.timeChoiceBtn = false;
                        this.isStock ='OFF';
                        this.vipEnable = false;
                        this.kitchenPrintEnabled = 'OFF';
                        this.isDirectThermal = 'OFF';
                        this.dialogVisible = true ;
                        this.pcEnable = true;
                        this.pcBuyEnable = true;
                       this.addCurGoodIdx = 0;
                       this.discountEnable = false;
                    }else if(boo=='search') {
                        this.goodCheckArr = []; 
                        this.vipData = [res.data];
                        if( this.vipData.length < 6 ){
                            for(let i = 0, len = 6 - this.vipData.length; i < len; i++){
                                this.vipData.push({})
                            }
                        }
                    }
                })
            },
            // 配品检索
            searchGoods(val,id){
                if ( !this.goodSearchBtn ) {
                    return;
                }
                this.goodSearchBtn = false;
                this.$http.get('products/stores-search?storeId='+(id?id:this.curStoreId)+'&stockEnabled=false'+'&q='+encodeURI(val)+'&matchProductEnabled=true').then((res)=>{
                    if(id){
                        this.addGoodCheckArr = res.data;
                        this.isAutoSearchBtn = false;
                        setTimeout(()=>{
                            this.isAutoSearchBtn = true;
                        },2000)
                        setTimeout(()=>{
                            let that = this;
                            $('.add_details_search li').hover( function () {
                                that.addCurGoodIdx = $(this).index()-1;
                            }, function () {
                                that.addCurGoodIdx = 0;
                            })
                        },0)
                    }else {
                        this.goodCheckArr = res.data;
                        setTimeout(()=>{
                            let that = this;
                            $('.details_search li').hover( function () {
                                that.curGoodIdx = $(this).index()-1;
                            }, function () {
                                that.curGoodIdx = 0;
                            })
                        },0)
                    }
                    this.goodSearchBtn = true;
                }).catch(()=>{
                    this.goodSearchBtn = true;
                })
            },
            //删除时段
            removeTimes(item){
                for (var i = 0; i < this.newTimeList.length; i++) {
                    if(this.newTimeList[i].id==item.id){
                        this.newTimeList.splice(i,1);
                    }
                }
            },
             //删除时段
            removeTimesForComm(item){
                for (var i = 0; i < this.newTimeListForComm.length; i++) {
                    if(this.newTimeListForComm[i].id==item.id){
                        this.newTimeListForComm.splice(i,1);
                    }
                }
            },
            addTimesForComm(){
                this.timeChoiceBtnForComm = true;                
            },
            //添加时段
            addTimes(item){
                this.timeChoiceBtn = true;
            },
            // 获取时段列表
            getTimesList: function () {
                this.$http.get('/product-supply-time?storeId='+this.curStoreId).then((res)=>{
                    let body = res.data;
                    if ( body && body[0] ) {
                        this.timeList = body;
                    }
                }).catch((err)=>{

                })
            },
            selOk(data){
                console.log(data);
                this.seledMats = data.nowSelectGoods;
                this.showMat = false;
            },
            uploadGood(item) {
                //修改配品
                this.btnId = item.id;
                this.addGoodCheckArr = [];
                this.isAutoSearchBtn = false;
                this.newGoods = {
                    productTypeId : item.typeId,
                    barCode       : item.barCode,
                    // costPrice     : item.costPrice,
                    salesPrice    : item.salesPrice,
                    inStockNumber : item.inStockNumber,
                    supplierName  : item.supplierName,
                    name          : item.name,
                    imageURL      : item.imageURL,
                    // productStatus : item.productStatus?'OFF':'ON',
                    // stockQuantityRatio : item.stockQuantityRatio,
                    commission : item.commission,
                    memberShow:item.memberShow,
                    disShow:item.disShow,
                    productQty:item.productQty,
                    labelEnabled:item.labelEnabled?1:0,
                    ipId:item.ipId==0?"":item.ipId,
                    threshold:item.threshold,//库存告警值
                    // 
                    sort:item.sort,
                    salesCount:item.salesCount,
                    salesShowEnabled:item.salesShowEnabled,
                    salesEnabled:item.salesEnabled,
                    timeRangeComm:item.openTimeEnabled,
                    note:item.note,
                    week:item.week ? item.week.split(",") : []
                };
                console.log(this.newGoods)
                if(this.newGoods.week && this.newGoods.week.length && this.newGoods.week.length == 7){
                    this.isAllWeek = true;
                }else{
                    this.isAllWeek = false;
                }
                if(item.productMaterialItems && Array.isArray(item.productMaterialItems) && item.productMaterialItems.length){
                    item.productMaterialItems.forEach(it=>{
                        it.formId = it.id;
                        it.name = it.productMaterialName;
                        it.count = it.qty;
                    })
                }
                this.seledMats = item.productMaterialItems;
                let newTimeListForComm = []
                for(let i=0;i<item.list.length;i++){
                    let obj = {
                        commission:item.list[i].commission,
                        timeRange:[new Date(`2020/01/01 ${item.list[i].begin}`),new Date(`2020/01/01 ${item.list[i].end}`)],
                    }
                    if(item.list[i].begin == "aN:aN:00" || item.list[i].end == "aN:aN:59"){
                        obj = {
                            commission:item.list[i].commission,
                            timeRange:["",""]
                        }
                    }
                    
                    newTimeListForComm.push(obj);
                }
                this.newTimeListForComm =newTimeListForComm;
                if(item.supplyTimes){
                    this.newTimeList = [];
                    let supplyTimes = JSON.parse(item.supplyTimes);
                    for(var i=0;i<supplyTimes.length;i++){
                        if(supplyTimes[i].id) {
                            this.newTimeList.push(supplyTimes[i])
                        }
                    }
                }else{
                    this.newTimeList = [];
                }
                this.timeChoiceBtn = false;
                this.isStock = item.stockEnabled?'ON':'OFF';
                this.kitchenPrintEnabled = item.kitchenPrintEnabled?'ON':'OFF';
                this.isDirectThermal = item.isDirectThermal?'ON':'OFF';
                this.dialogVisible = true ;
                // 
                this.vipEnable = item.memberShow;//是否开启会员价格
                this.vipPrice = item.memberPrice//会员价格
                this.discountEnable = item.disShow//是否开启折扣
                this.discountPrice = (item.disPrice)*100;//折扣百分比
                let dateForBeg = new Date("2018-11-11 "+item.nowHours);
                let dateForEnd = new Date("2018-11-11 "+item.tomorrowHour);
                this.beginTime = dateForBeg;//折扣起始时间
                this.endTime = dateForEnd;//折扣终止时间
                this.disCom = item.disCom;
                // this.croseDay = item.cross;//折扣时间是否跨天s

                // 是否显示在客户端和是否是否允许购买
                this.pcEnable = item.showEnabled;
                this.pcBuyEnable = item.purchaseEnabled;
            },
            //初始化 配品数据
            initDate(){
                this.timeChoiceBtn = false;
                this.isAutoSearchBtn = true;
                this.btnId = null;
                this.addId = null;
                this.newGoods = {
                    id: '', // 员工id
                    productTypeId: '', // 配品id
                    name: '', // 员工姓名
                    barCode: '', // 条码
                    // costPrice: '', // 进价
                    salesPrice: '', // 出售价
                    storeId: this.curStoreId, // 商铺id
                    inStockNumber: '' ,// 库存
                    supplierName: '', // 供应商
                    productStatus: 'ON', // 状态
                    imageURL: '', // 图片路径
                    // stockQuantityRatio : '',
                    commission:'0',//配品提成
                    productQty:1,//默认配品数量
                    labelEnabled:0,
                    ipId:"",
                    threshold:0,
                    // 
                    sort:0,
                    salesCount:0,
                    salesShowEnabled:false,
                    salesEnabled:false,
                    timeRangeComm:false,
                    note:"",
                    week:[]
                }

                this.newTimeList = [];
                this.seledMats = [];
                this.newTimeListForComm = [{
                    commission:"",
                    timeRange:[]
                }];
                this.isStock = 'OFF';
                // 
                this.discountEnable = false;
                this.vipEnable = false;
                this.discountPrice = 100,
                this.vipPrice = "";
                this.beginTime = "";
                this.endTime = "";
                this.disCom = 0;
                // 
            },
            addGoods(){
                //点击添加配品，清空 newGoods并获取获取配品分类
                this.dialogVisible = true;
                this.initDate();
            },
            // 筛选配品
            fliterGoods () {
                let fliter_stock = '-1';
                let fliter_kitchen = '-1';
                if ( this.fliter_stock == 'true' ) {
                    fliter_stock = 1;
                } else if ( this.fliter_stock == 'false' ) {
                    fliter_stock = 0;
                }
                if ( this.fliter_kitchen == 'true' ) {
                    fliter_kitchen = 1;
                } else if ( this.fliter_kitchen == 'false' ) {
                    fliter_kitchen = 0;
                }

                this.$http.get('/products?storeId='+this.curStoreId+'&typeId='+this.fliter_type+'&isStock='+fliter_stock+'&kitchen='+fliter_kitchen+"&matchProductEnabled=true").then((res)=>{
                    this.vipData = res.data;
                    this.goodsNum.total = res.data.length;
                    if( this.vipData.length < 6 ){
                        for(let i = 0, len = 6 - this.vipData.length; i < len; i++){
                            this.vipData.push({})
                        }
                    }
                })
            },
            // 删除配品
            delGoods(goodId){

                this.$confirm('温馨提示：删除该配品后，与之绑定的商品关联将取消', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    //删除配品
                   this.$http.delete('/products?id='+goodId).then((res)=>{
                        if( res.status ){
                            if(this.fliter_type!=''||this.fliter_stock!=''||this.fliter_kitchen!=''){
                                this.fliterGoods();
                            }else{
                                this.getGoodsData();
                            }
                        }
                    })
                }).catch(() => {});
            },
            getGoodsData(){
                // this.$http.get('/products?storeId='+this.curStoreId).then((res)=>{
                this.$http.get('/get-ps?storeId='+this.curStoreId+"&matchProductEnabled=true").then((res)=>{
                    this.vipData = res.data;
                    this.goodsNum.total = res.data.length;
                    if( this.vipData.length < 6 ){
                        for(let i = 0, len = 6 - this.vipData.length; i < len; i++){
                            this.vipData.push({})
                        }
                    }
                })
            },
            checkFn(){
                //正则验证方法
                if(!this.newGoods.name){
                    this.$message({
                        message: '请输入配品名',
                        customClass: 'error'
                    })
                    return true;
                }
                if(this.newGoods.note!=null){
                    if(this.newGoods.note.length>15){
                        this.$message({
                            message: '配品描述最长15个字符',
                            customClass: 'error'
                        })
                        return true;
                    }
                }
                
                // 分类限制，如果选择了网费分类，配品名则必须含有网费字眼，其他配品转为网费分类同样需要网费字眼
                if(this.newGoods.productTypeId == 1){
                    if(!/(\u7f51\u8d39)/.test(this.newGoods.name)){
                        this.$message({
                            message: '当前选择了火星网费分类，配品名必须含有网费字眼。',
                            customClass: 'error'
                        })
                        return true;
                    }
                }else{
                   if(/(\u7f51\u8d39)/.test(this.newGoods.name)){
                        this.$message({
                            message: '当前分类下，配品名不能含有网费字眼。',
                            customClass: 'error'
                        })
                        return true;
                    } 
                }
                // 
                if(this.isStock=="ON"){
                    if(!/(^0{1}$)|(^[1-9][0-9]*$)/.test(this.newGoods.threshold)){
                        this.$message({
                            message: '数量输入有误',
                            customClass: 'error'
                        })
                        return true;
                    }
                }else if(this.isStock=="OFF"){
                    // if(!/^\d+(\.{0,1}\d+){0,1}$/.test(this.newGoods.stockQuantityRatio)){
                    //     this.$message({
                    //         message: '配品规格格式有误',
                    //         customClass: 'error'
                    //     })
                    //     return true;
                    // }
                }
                if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.newGoods.salesPrice)){
                    this.$message({
                        message: '销售价格格式有误',
                        customClass: 'error'
                    })
                    return true;
                }
                if(!/^[1-9][0-9]*$/.test(this.newGoods.productQty)){
                    this.$message({
                        message: '数量输入有误',
                        customClass: 'error'
                    })
                    return true;
                }
                if(this.vipEnable){
                    if(!this.vipPrice){
                      this.$message({
                            message: '请输入会员价',
                            customClass: 'error'
                        })
                        return true;  
                    }
                    if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.vipPrice)){
                        this.$message({
                            message: '会员价格格式有误',
                            customClass: 'error'
                        })
                        return true;
                    }
                }
                if(this.discountEnable){
                    if(!this.discountPrice){
                      this.$message({
                            message: '请输入折扣百分比',
                            customClass: 'error'
                        })
                        return true;  
                    }
                    if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.discountPrice)){
                        this.$message({
                            message: '折扣格式有误',
                            customClass: 'error'
                        })
                        return true;
                    }
                    if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.disCom)){
                        this.$message({
                            message: '提成价格格式有误',
                            customClass: 'error'
                        })
                        return true;
                    }
                    if(!this.beginTime||!this.endTime){
                        this.$message({
                            message: '折扣时间有误',
                            customClass: 'error'
                        })
                        return true;
                    }
                    if(this.beginTime=="aN:aN:aN"||this.endTime=="aN:aN:aN"){
                       this.$message({
                            message: '折扣时间有误',
                            customClass: 'error'
                        })
                        return true; 
                    }
                }
                
                if(!this.newGoods.productTypeId){
                    this.$message({
                        message: '请选择分类',
                        customClass: 'error'
                    })
                    return true;
                }
                if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.newGoods.commission)){
                    this.$message({
                        message: '配品提成格式有误',
                        customClass: 'error'
                    })
                    return true;
                }
                if(this.newGoods.salesShowEnabled){
                    if(!/^\d*$/.test(this.newGoods.salesCount)){
                        this.$message({
                            message: '基础数量输入有误',
                            customClass: 'error'
                        })
                        return true;
                    }
                    if(!/^\d*$/.test(this.newGoods.sort)){
                        this.$message({
                            message: '排序输入错误',
                            customClass: 'error'
                        })
                        return true;
                    }
                }
            },
            upGoods(){
                // console.log(this.newTimeListForComm);
                // console.log(new Date((this.newTimeListForComm[0].timeRange[0])).Format("hh:mm:00"))
                // return;
                
                if(this.checkFn()) {
                    //正则验证
                    return;
                }
                if ( !this.addGoodApiBtn ) {
                    return;
                }
                this.addGoodApiBtn = false;
                let commTimeArr = [];
                if(this.newGoods.timeRangeComm){
                    for(let i=0;i<this.newTimeListForComm.length;i++){
                         if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.newTimeListForComm[i].commission)){
                            this.$message({
                                message: '配品提成格式有误',
                                customClass: 'error'
                            })
                            this.addGoodApiBtn = true;
                            return true;
                        }
                        if(!this.newTimeListForComm[i].timeRange||!this.newTimeListForComm[i].timeRange[0]||!this.newTimeListForComm[i].timeRange[1]||this.newTimeListForComm[i].timeRange.length==0){
                            this.$message({
                                message: '请选择时间',
                                customClass: 'error'
                            })
                            this.addGoodApiBtn = true;
                            return true;
                        }
                        let obj = {
                            commission:Number(this.newTimeListForComm[i].commission),
                            begin:new Date(this.newTimeListForComm[i].timeRange[0]).Format("hh:mm:00"),
                            end:new Date(this.newTimeListForComm[i].timeRange[1]).Format("hh:mm:59")
                        }
                        commTimeArr.push(obj);
                    }
                }

                let flag = false;
                let newTimeListForComm = commTimeArr;
                if(newTimeListForComm.length>1){
                    for(let i=1;i<newTimeListForComm.length;i++){
                        
                        let tempArrMax = [new Date(`2020/01/01 ${newTimeListForComm[0].begin}`).getTime(),new Date(`2020/01/01 ${newTimeListForComm[i].begin}`).getTime()];
                        let tempArrMin = [new Date(`2020/01/01 ${newTimeListForComm[0].end}`).getTime(),new Date(`2020/01/01 ${newTimeListForComm[i].end}`).getTime()];


                        // let tempArrMax = [item.startTimeForFee,newTimeListForComm[i].startTimeForFee];
                        // let tempArrMin = [item.endTimeForFee,newTimeListForComm[i].endTimeForFee];
                        if(Math.max.apply(null, tempArrMax)<= Math.min.apply(null, tempArrMin)){
                            flag = true;
                        }
                    }
                }
                if(flag){
                    this.$message({
                        message: "时间不允许重叠，请重新选择",
                        customClass: 'error'
                    });
                    this.addGoodApiBtn = true;
                    return;
                }


                let arr1 = this.newTimeList;
                let arr2 = this.timeList;
                let supplyTimes = [];
                if(arr1.length){
                    for(var i=0;i<arr1.length;i++){
                        for(var j=0;j<arr2.length;j++){
                            if(arr1[i].id==arr2[j].id){
                                supplyTimes.push(arr2[j])
                            }
                        }
                    }
                }
                let ipName="";
                let port=0;
                let ipAddress = "";

                if(this.newGoods.ipId!=0 && this.newGoods.ipId){
                    for(let i=0;i<this.printEr.length;i++){
                        if(this.printEr[i].id==this.newGoods.ipId){
                            ipName = this.printEr[i].name;
                            port = this.printEr[i].port;
                            ipAddress = this.printEr[i].ipAddress;
                        }
                    }
                }
                let gname = String(this.newGoods.name.replace(/\s*/g,""));
                let goods = {
                    "id":this.btnId ? this.btnId : "",
                    "storeId"       :  this.curStoreId,
                    "name"          :  gname,
                    "salesPrice"    :  parseFloat(this.newGoods.salesPrice),
                    "productTypeId" : this.newGoods.productTypeId,
                    "stockEnabled" : this.isStock==='OFF'? false : true,
                };
                this.$http.post('/match/product/edit',goods).then((res)=>{
                    this.addGoodApiBtn = true;
                    this.isAutoSearchBtn = true;
                    if ( !this.btnId ) {
                        this.$message({
                            message: '添加配品成功',
                            customClass: 'success'
                        });
                        setTimeout( ()=> { 
                            this.initDate();
                        },500);
                        
                    } else {
                        this.$message({
                            message: '修改配品成功',
                            customClass: 'success'
                        });
                        this.dialogVisible = false;
                    }
                    setTimeout(()=>{
                        // this.getGoodsData();
                        if(this.fliter_type!=''||this.fliter_stock!=''||this.fliter_kitchen!=''){
                            this.fliterGoods();
                        }else{
                            this.getGoodsData();
                        }
                    },1000);
                    // 
                    let params = [];
                    if(this.seledMats && Array.isArray(this.seledMats) && this.seledMats.length){
                        this.seledMats.forEach(it=>{
                            let obj = {
                                id:it.formId?it.formId:0,
                                qty:it.count,
                                productMaterialId:it.productMaterialId,
                                productMaterialName:it.name,
                            }
                            params.push(obj);
                        })
                    }
                    this.upOriGoods(res.data.id,params);
                    // 
                }).catch(()=>{
                    this.addGoodApiBtn = true;
                })
            },
            upOriGoods(productId,params){
                this.$http({
                    url:"edit/material",
                    method:"POST",
                    data:{
                        productId,
                        params
                    }
                });
            },
            // 设置客户端是否允许购买和显示
            setForPc(productId,showEnabled,purchaseEnabled){
                this.$http({
                    url:"show-enabled",
                    method:"POST",
                    data:{
                       productId,
                       showEnabled:showEnabled?1:0,
                       purchaseEnabled:purchaseEnabled?1:0
                    }
                }).then(res=>{
                    console.log(res);
                })
            },
            disOrVip(productId,memberPrice,disPrice,disCom,beginTime,endTime){
                if(beginTime!="aN:aN:aN" && endTime!="aN:aN:aN" && this.discountEnable){
                    if(new Date(`2020/01/01 ${endTime}`).getTime() <= new Date(`2020/01/01 ${beginTime}`).getTime()){
                        this.$message({
                        message: '折扣结束时间不能小于开始时间',
                        customClass: 'error'
                        })
                        return false;
                    }
                }
                   let data={
                        productId,
                        beginTime:beginTime=="aN:aN:aN"?"":beginTime,
                        endTime:endTime=="aN:aN:aN"?"":endTime,
                        disShow:this.discountEnable?1:0,
                        disPrice:(disPrice/100).toFixed(2),
                        memberShow:this.vipEnable?1:0,
                        memberPrice,
                        disCom
                    } 
                this.$http({
                    url:"update-slot",
                    method:"POST",
                    data
                }).then(res=>{
                    console.log(res);
                })
                return true;
            },
            coverImg: function ( e ) {
                let reader = new FileReader();
                let that = this;
                let fileObj = e.target.files[0];

                if( e.target.files.length == 0 ) {
                    return false;
                }

                // 判断图片大小
                if( fileObj.size > this.coverImgMaxSize ) {
                    this.errorMsg = '上传图片的大小不能超过5MB';
                    this.openErrorTip = true;
                    this.$message({
                        message: '上传图片的大小不能超过5MB',
                        customClass: 'error'
                    })
                    return false;
                }

                reader.onload = (function (file) {
                    return function (e) {
                        let that2 = this; // 缓存当前this
                        let img = new Image();
                        img.src= this.result;
                        img.onload=function(){
                            let imgBase64 = that2.result; //获得图片的base64的数据


                            // 判断是否是移动端设备
                            let sUserAgent = navigator.userAgent.toLowerCase();
                            let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
                            let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
                            let bIsMidp = sUserAgent.match(/midp/i) == "midp";
                            let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
                            let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
                            let bIsAndroid = sUserAgent.match(/android/i) == "android";
                            let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
                            let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
                            if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                                that.mobileUploadImg(imgBase64);
                            } else {
                                that.oldImgBase64 = imgBase64;
                                that.showCrop = true;
                            }
                        };
                        $('.pcImgFile').val('');
                        $('.mobileImgFile').val('');
                    };
                })(e.target.files[0]);
                reader.readAsDataURL(e.target.files[0]);
            },
            // 移动端上传图片
            mobileUploadImg: function (imgBase64) {
                this.infoload = true;
                this.$http.post(API_BASE_URL+'v1/image/json/upload?storeId='+this.curStoreId, {file: imgBase64}).then((res)=>{
                    this.newGoods.imageURL = res.data.path;
                    this.infoload = false;
                }).catch(()=>{
                    this.infoload = false;
                });
            },
            // 获得裁剪后图片base64
            getCropImgBase: function ( imgUrl )　{
                this.newGoods.imageURL = imgUrl;
            }
        },
        activated: function () {
            for (let i = 0; i < 6; i++) {
                this.vipData.push({});
            }

            //获取配品分类
            /*this.$http.get('/product-types-all?storeId='+this.curStoreId+'&parentId='+'').then((res)=>{
                this.typeList = this.typeList.concat(res.data);
               
                this.typeOptions.push({label: '全部',value: ''});
                for (var i = 0; i < res.data.length; i++) {
                    let obj={
                        value:res.data[i].id,
                        label:res.data[i].name
                    }
                    if(res.data[i].productTypeVos.length){
                        let son = res.data[i].productTypeVos;
                        let arr = [
                            {value:res.data[i].id,label:res.data[i].name}
                        ];
                        for (var j = 0; j < son.length; j++) {
                             let sonobj={
                                value:son[j].id,
                                label:"- "+son[j].name
                            }
                            arr.push(sonobj)
                        }
                        obj.children = arr;
                    }
                    this.typeOptions.push(obj);
                }
            })*/
            this.$http.get('/product-types?storeId='+this.curStoreId+'&parentId='+'').then((res)=>{
                this.typeList = res.data.data;
                this.systemData = res.data.systemData;
            })
            if(this.fliter_type!=''||this.fliter_stock!=''||this.fliter_kitchen!=''){
                this.fliterGoods();
            }else{
                this.getGoodsData();
            }
            this.getTimesList();
            this.getPrintIpInfo();
        },
        mounted() {
            // 改变关闭样式
            $(document).ready(()=>{
                $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
                $('.el-message-box__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
            });
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/el-dialog.scss';
    @import '../../tableTemplate/tableTem.scss';
	@import "info.scss";
    .mat-goods{
        width: 100%;
        padding-left:55px;
    }
    .seled-mat-list{
        margin-top: 10px;
    }
    .el-tag{
        margin: 0 5px;
        background-color: #3068ff;
    }
</style>



// WEBPACK FOOTER //
// info.vue?6311cb01